import React from 'react'

export const withFileInput = Component => {
  return class extends React.Component {
    state = {
      file: undefined,
    }

    handleChange = e => {
      const file = e.target.files[0]
      this.setState(setFile(file))
      if (this.props.onChange) {
        this.props.onChange(file)
      }
    }

    render() {
      return (
        <Component
          {...this.props}
          onChange={this.handleChange}
          file={this.state.file}
        />
      )
    }
  }
}

const setFile = file => state => ({
  file,
})



// WEBPACK FOOTER //
// ./src/modules/file-input/index.js